import { GetUserImage } from 'Global/Adapters/GetUserImage';
import Cookies from 'js-cookie';
import React from 'react';

const useGetProfileImageOnMount = (setRefreshForImage) => {
  const Data =
    Cookies.get('user') && JSON.parse(Cookies.get('user'));
  React.useEffect(() => {
    GetUserImage(Data)
      .then((response) => {
        if (response) {
          localStorage.setItem(
            'userImage',
            JSON.stringify(response.data.Data)
          );
        }
      })
      .then(() => setRefreshForImage((prev) => !prev));
  }, []);
};

export default useGetProfileImageOnMount;
